import { type Repub } from '@cx-modules/constants';

export const repubs: ReadonlyArray<readonly [Repub, string]> = [
  ['OC', '/'],
  ['US', 'us/'],
  ['DE', 'de/'],
  ['CO', 'co/'],
  ['AU', 'au/'],
  ['NZ', 'nz/'],
  ['IN', 'in/'],
  ['PT', 'pt/'],
  ['ZA', 'za/'],
  ['KE', 'ke/'],
  ['NG', 'ng/'],
  ['NL', 'nl/'],
  ['FR', 'fr/'],
  ['SE', 'se/'],
  ['SM', 'sm/'],
  ['CX', 'cx/'],
  ['CA', 'ca/'],
  ['ES', 'es/'],
  ['IT', 'it/'],
  ['BR', 'br/'],
  ['GZ', '/'],
  ['WS', '/'],
];

function formatRepubPath(repub: Repub, useRootSlash: boolean): string {
  const repubEntry = repubs.find(([code]) => code === repub);
  if (!repubEntry) return useRootSlash ? '/' : '';

  const path = repubEntry[1];
  if (path === '/') return useRootSlash ? '/' : '';

  return `/${path.replace(/\/$/, '')}`;
}

export function getRepubPath(repub: Repub): string {
  return formatRepubPath(repub, false);
}

export function getRepubHomeUrl(repub: Repub): string {
  return formatRepubPath(repub, true);
}
